import React from "react";
import { RCCSwitch } from "react-common-components";
import ScheduleRestriction from "src/components/ScheduleRestriction";
import { useTranslation } from "src/context/Translations/context";
import { IRestrictions } from "../../interface";

const Restrictions: React.FC<IRestrictions> = ({
	refSchedule,
	data,
	register
}) => {

	const { translate } = useTranslation();

	return (
		<>
			<ScheduleRestriction ref={refSchedule} data={data.schedule}/>
			<RCCSwitch 
				name="validateIP"
				register={register}
				label={translate("Validar IP de acesso")}
				defaultChecked={data.validateIp}	
			/>
		</>
	);
};

export default Restrictions;
